'use es6';

import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import UsageTracker from '../lib/usageTracker';
var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // Usage tracking middleware should be moved to a better handler pattern.
// this was done to support the redux update.

var usageTrackerMiddleware = function usageTrackerMiddleware() {
  return function (next) {
    return function (action) {
      UsageTracker.logActionChange(action);
      return next(action);
    };
  };
};

var createStoreWithMiddleware = composeEnhancers(applyMiddleware(thunk, usageTrackerMiddleware))(createStore);
export default function configureStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return createStoreWithMiddleware(rootReducer, initialState);
}